import { store } from "../../..";
import { API } from "../../../../legacy/api";
import * as validate from "../../../validation";
import * as actions from "../../Menu/Common/Menu.actions";

API.on("gamerules.content.set", (content: string) => {
  if (validate.tabContent(content)) {
    store.dispatch(actions.setGameRulesContent(content));
  }
});

API.on("gamerules.available.set", (value: boolean) => {
  store.dispatch(actions.setGameRulesAvailable(value));
});

API.on("gamehistory.available.set", (value: boolean) => {
  store.dispatch(actions.setGameHistoryAvailable(value));
});

API.on("gamehistory.enabled", (enabled: boolean) => {
  const gameHistoryEnabled = store.getState().keypad.gameHistoryEnabled;

  if (
    validate.gameHistory(enabled, "gamehistory.enable") &&
    gameHistoryEnabled !== enabled
  ) {
    store.dispatch(actions.setGameHistoryEnabled(enabled));
  }
});
